var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.0003C1.5 23.4001 1.5 25.6 2.86684 26.9668C4.23367 28.3337 6.43356 28.3337 10.8333 28.3337C15.2331 28.3337 17.433 28.3337 18.7998 26.9668C20.1667 25.6 20.1667 23.4001 20.1667 19.0003C20.1667 14.6006 20.1667 12.4007 18.7998 11.0338C17.433 9.66699 15.2331 9.66699 10.8333 9.66699C6.43356 9.66699 4.23367 9.66699 2.86684 11.0338C1.5 12.4007 1.5 14.6006 1.5 19.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.7268 1.66699L14.9326 3.14716C13.9775 3.93504 13.5 4.32898 13.5 4.81851L14.8333 4.81851C19.8616 4.81851 22.3758 4.81851 23.9379 6.3806C25.5 7.9427 25.5 10.4569 25.5 15.4852V16.3337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate_left.f81140996f082956ddab32ebd517fc62.svg";
export { ForwardRef as ReactComponent };